module.exports = {"moreInfo":[],"moreInfoText":[]}


//////////////////
// WEBPACK FOOTER
// ./config/exports/moreInfo/parking/SEN.json
// module id = 364
// module chunks = 119